import axios from 'axios'

export class KassenprojektPfand{
    static async get(kassenProjektID, feuerwehrID, timeout = 1500){
        try {
            const response = await axios.get(
              'https://feuerwehr-server.org:5000/kassenprojektPfand', { params: { kassenProjektID: kassenProjektID, feuerwehrID: feuerwehrID  }, timeout }
            );
              console.log(response.data);
              return response.data;
          } catch (err) {
            console.error(err);
            throw err;
          }
    }
    static async add(pfand){
        try {
            const response = await axios.post('https://feuerwehr-server.org:5000/addKassenprojektPfand', pfand);
            console.log(response.data);
        } catch (err) {
            console.error(err);
        }
    }
    static async update(pfand, timeout = 1500){
        try {
            const response = await axios.put('https://feuerwehr-server.org:5000/updateKassenprojektPfand', pfand,{timeout});
            console.log(response.data);
            return true;
         } catch (err) {
            console.error(err);
            throw err;
        }
    }
    static async delete(a){
        try{
            const response = await axios.delete(
                'https://feuerwehr-server.org:5000/deleteKassenprojektPfand',
                { params: { kassenProjektID: a.kassenProjektID, feuerwehrID: a.feuerwehrID, kassenProjektPfandID: a.kassenProjektPfandID } }
            );
            console.log(response.data);
            return true;
        } catch (err){
            console.log(err);
            return false;
        }
    }
}
